module.exports = __webpack_public_path__ + "europa-50-signature.jpg?5a87b4c9c8f94fecbc3ae197bd71d296";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/europa-50-signature.jpg
// module id = 366
// module chunks = 0